/** @format */

import React, { useState } from "react";
import { connect } from "react-redux";
import Spinner from "../Spinner/Spinner";
import { logger } from "@goldenbird1/ui-logger-library";
import { v4 as uuidv4 } from "uuid";

function NewsRoom(props) {
  const [htmlContent, setHtmlContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useState(() => {
    let buyerId = props.userProfile && props.userProfile?.userProfile?.profileId ? props.userProfile.userProfile.profileId : null;
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/content/v1/Newsroom";
    fetch(url, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res.statusText || "COntent not found";
        }
      })
      .then((res) => {
        setHtmlContent(res.body);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        logger(
          "error",
          "Error from useEffect method Newsroom: " +
            url +
            ": buyerId =>  " +
            buyerId +
            ": error => " +
            error,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
      });
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <React.Fragment>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    userProfile: state.userProfile
  };
};

export default connect(mapStateToProps, null)(NewsRoom);
